import type { SVGProps } from 'react';
const SvgCheckboxChecked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <rect fill="currentColor" height={18} width={18} rx={4} />
    <path d="M5 10.813 7.105 13 13 6" strokeLinecap="square" strokeWidth={2} stroke="#fff" />
  </svg>
);
export default SvgCheckboxChecked;
